module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_welcome_board-e5f57ecbc92148d5e308162f357dec10.jpg";